import React, {useState} from "react";
import styled from "styled-components";
import axios from "axios";
import DemoSubmission from "./Demo";
import Image from "./Image";
import {BASE_URL} from "../home/BASE_URL";
import {message} from "antd";

const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: ${({show}) => (show ? "flex" : "none")};
    align-items: center;
    justify-content: center;
`;

const ModalContent = styled.div`
    background: #fff;
    padding: 30px;
    border-radius: 12px;
    text-align: center;
`;

const FormSection = styled.div`
    padding: 2rem;
    background: rgb(31, 1, 16);

    @media (max-width: 768px) {
        padding: 1rem;
    }
`;

const FormContainer = styled.div`
    max-width: 600px;
    margin: auto;
    background: #222;
    color: rgb(0, 195, 255);
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
        padding: 1.2rem;
    }
`;

const Heading = styled.h2`
    font-size: 2rem;
    margin-bottom: 1rem;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 1.2rem;
    }
`;

const Subtext = styled.p`
    font-size: 1.1rem;
    margin-bottom: 2rem;
    color: #ddd;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 0.9rem;
    }
`;

const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
`;

const FormGroup = styled.div`
    margin-bottom: 1.25rem;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
`;

const Input = styled.input`
    width: 100%;
    padding: 0.6rem;
    border-radius: 8px;
    background: #333;
    border: 1px solid #444;
    color: white;

    &:focus {
        border: 1px solid rgb(0, 195, 255);
        transition: border 0.5s;
    }
`;

const TextArea = styled.textarea`
    width: 100%;
    padding: 0.6rem;
    border-radius: 8px;
    background: #333;
    border: 1px solid #444;
    color: white;

    &:focus {
        border: 1px solid rgb(0, 195, 255);
        transition: border 0.5s;
    }
`;

const Button = styled.button`
    padding: 0.8rem;
    background: #f03e3e;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 1rem;

    &:disabled {
        background: #aaa;
        cursor: not-allowed;
    }
`;

const Select = styled.select`
    width: 100%;
    padding: 0.6rem;
    border-radius: 8px;
    background: #333;
    border: 1px solid #444;
    color: white;

    &:focus {
        border: 1px solid rgb(0, 195, 255);
        transition: border 0.5s;
    }
`;

const ArtistRegistrationForm = () => {
    const [formData, setFormData] = useState({
        stageName: "",
        realName: "",
        email: "",
        genre: "",
        bio: "",
        spotify: "",
        gender: "",
        audiomack: "",
        profileImage: null,
        preview: null,
    });

    const [demoFile, setDemoFile] = useState(null);
    const [audioPreview, setAudioPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [fileName, setFileName] = useState("");
    const [fileName1, setFileName1] = useState("");

    const MAX_FILE_SIZE_MB = 5;

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
            message.error("File too large. Max allowed is 5MB.");
            return;
        }

        if (type === "image") {
            if (!file.type.startsWith("image/")) {
                message.error("Please upload a valid image file.");
                return;
            }
            setFormData({
                ...formData,
                profileImage: file,
                preview: URL.createObjectURL(file),
            });
            setFileName1(file.name);
        } else if (type === "demo") {
            if (!file.type.startsWith("audio/")) {
                message.error("Please upload a valid audio file.");
                return;
            }
            setDemoFile(file);
            setAudioPreview(URL.createObjectURL(file));
            setFileName(file.name);
        }
    };

    const resetForm = () => {
        setFormData({
            stageName: "",
            realName: "",
            email: "",
            genre: "",
            bio: "",
            spotify: "",
            gender: "",
            audiomack: "",
            profileImage: null,
            preview: null,
        });
        setDemoFile(null);
        setAudioPreview(null);
        setFileName("");
        setFileName1("");
        URL.revokeObjectURL(formData.preview);
        URL.revokeObjectURL(audioPreview);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!/\S+@\S+\.\S+/.test(formData.email)) {
            message.error("Please enter a valid email address.");
            return;
        }

        const requiredFields = ["stageName", "realName", "genre"];
        const missing = requiredFields.filter((field) => !formData[field]);

        if (missing.length > 0 || !formData.profileImage || !demoFile) {
            message.error("Please fill out all required fields and upload files.");
            return;
        }

        const form = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (key !== "preview") form.append(key, value);
        });
        form.append("demoFile", demoFile);

        try {
            setLoading(true);
            console.log(form);

            await axios.post(`${BASE_URL}/artists/register`, form, {
                headers: {"Content-Type": "multipart/form-data"},
            });

            await axios.post(`${BASE_URL}/send-registration-mail-to-admin`, {
                name: formData.stageName,
                email: formData.email,
            });

            setShowModal(true);
        } catch (err) {
            const msg = err.response?.data?.message || "Something went wrong. Please try again.";
            message.error(msg);
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <FormSection>
                <FormContainer>
                    <Heading>Think you’ve got what it takes?</Heading>
                    <Subtext>Drop your demo and join the XTiiM family.</Subtext>
                    <StyledForm onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label htmlFor="stageName">Stage Name *</Label>
                            <Input
                                id="stageName"
                                placeholder="enter your stage name"
                                name="stageName"
                                value={formData.stageName}
                                onChange={handleChange}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="realName">Real Name *</Label>
                            <Input
                                id="realName"
                                placeholder="enter your real name"
                                name="realName"
                                value={formData.realName}
                                onChange={handleChange}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="email">Email *</Label>
                            <Input
                                id="email"
                                placeholder="enter your email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="genre">Genre *</Label>
                            <Input
                                id="genre"
                                placeholder="enter your genre"
                                name="genre"
                                value={formData.genre}
                                onChange={handleChange}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="bio">Bio *</Label>
                            <TextArea
                                id="bio"
                                placeholder="enter your bio here"
                                name="bio"
                                rows="4"
                                value={formData.bio}
                                onChange={handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="spotify">Spotify URL *</Label>
                            <Input
                                id="spotify"
                                placeholder="enter your spotify url link"
                                name="spotify"
                                value={formData.spotify}
                                onChange={handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="gender">Gender *</Label>
                            <Select id="gender" name="gender" value={formData.gender} onChange={handleChange} required>
                                <option value="">-- Select Gender --</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Non-binary">Non-binary</option>
                                <option value="Prefer not to say">Prefer not to say</option>
                                <option value="Other">Other</option>
                            </Select>
                        </FormGroup>

                        <FormGroup></FormGroup>
                        <FormGroup>
                            <Label htmlFor="audiomack">Audiomack URL *</Label>
                            <Input
                                id="audiomack"
                                placeholder="enter your audiomark url link"
                                name="audiomack"
                                value={formData.audiomack}
                                onChange={handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Image fileName1={fileName1} handleFileChange={handleFileChange} />
                            {formData.preview && (
                                <img
                                    src={formData.preview}
                                    alt="Preview"
                                    style={{width: "20%", borderRadius: "50px", marginTop: "10px", objectFit: "cover"}}
                                />
                            )}
                        </FormGroup>
                        <FormGroup>
                            <DemoSubmission fileName={fileName} handleFileChange={handleFileChange} />
                            {audioPreview && (
                                <audio controls>
                                    <source src={audioPreview} />
                                    Your browser does not support audio.
                                </audio>
                            )}
                        </FormGroup>
                        <Button type="submit" disabled={loading}>
                            {loading ? "Submitting..." : "Submit Application"}
                        </Button>
                    </StyledForm>
                </FormContainer>
            </FormSection>
            <Modal show={showModal}>
                <ModalContent>
                    <h2>Submission Successful!</h2>
                    <p>We’ve received your application and will review it shortly.</p>
                    <Button
                        onClick={() => {
                            setShowModal(false);
                            resetForm();
                        }}
                    >
                        Close
                    </Button>
                </ModalContent>
            </Modal>
        </>
    );
};

export default ArtistRegistrationForm;
